import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of, take } from 'rxjs';

import { CompanyStructureModel } from '../model';
import { CompanyStructureService } from '../service';

/** Struktur → Funktionen is only for admins of the root company; everyone else goes back to the structure. */
export const structureFeaturesGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);

  return inject(CompanyStructureService).structure.observable.pipe(
    take(1),
    map((structure: CompanyStructureModel): boolean | UrlTree =>
      structure.canManageFeatures ? true : router.createUrlTree(['/profile/structure']),
    ),
    catchError(() => of(router.createUrlTree(['/profile/structure']))),
  );
};
